import { z } from "zod"

export const kWkWhSchema = z.object({
  kWh: z.number(),
  kW: z.number(),
})

export type KWkWh = z.infer<typeof kWkWhSchema>
